import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
export { default as extend } from './extend';
function accountUrl() {
  return app.forum.attribute('loginOnlyAccountUrl') || '';
}

// A plain external <a>, not Button/LinkButton: Button always renders a
// <button> (an href attr on it is inert), and LinkButton's Link is for
// Mithril in-app routes, not an external URL opened in a new tab.
function ManageAccountLink(className) {
  const url = accountUrl();
  return url && m("p", {
    className: className
  }, m("a", {
    className: "Button Button--text Button--link",
    href: url,
    target: "_blank",
    rel: "noopener noreferrer"
  }, app.translator.trans('hli-oauth-login-only.forum.log_in.manage_account_link')));
}
app.initializers.add('hli-oauth-login-only', () => {
  // LogInModal/SettingsPage are lazy-loaded chunks in core: dynamically
  // importing them is only safe once the app has finished booting (the
  // chunk-loading mechanism needs `app.forum` etc., which aren't set up
  // yet while initializers are still running) — hence beforeMount, rather
  // than a top-level import or a call straight in the initializer body.
  app.beforeMount(() => {
    flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal').then(_ref => {
      let {
        default: LogInModal
      } = _ref;
      // Only the OAuth provider button(s) remain — no local identification,
      // password, "remember me", or local-submit fields.
      extend(LogInModal.prototype, 'fields', items => {
        items.remove('identification');
        items.remove('password');
        items.remove('remember');
        items.remove('submit');
      });

      // Replace "forgot password" / "sign up" with a link to the configured
      // account-management URL, if any.
      override(LogInModal.prototype, 'footer', function () {
        return ManageAccountLink('LogInModal-forgotPassword');
      });
    });
    flarum.reg.asyncModuleImport('flarum/forum/components/SettingsPage').then(_ref2 => {
      let {
        default: SettingsPage
      } = _ref2;
      // Local password/email changes are disabled (and blocked server-side);
      // point at the account-management URL instead.
      extend(SettingsPage.prototype, 'accountItems', function (items) {
        items.remove('changePassword');
        items.remove('changeEmail');
        const url = accountUrl();
        if (url) {
          items.add('manageAccount', m("a", {
            className: "Button",
            href: url,
            target: "_blank",
            rel: "noopener noreferrer"
          }, app.translator.trans('hli-oauth-login-only.forum.settings.manage_account_button')), 100);
        }
      });
    });
    flarum.reg.asyncModuleImport('flarum/forum/components/SignUpModal').then(_ref3 => {
      let {
        default: SignUpModal
      } = _ref3;
      // mySLP already locks username+email in the registration token
      // (SlpProvider::suggestions() uses provide(), not suggest()), and
      // GuardLocalUserChanges only lets account creation through with a
      // valid OAuth token — so this modal only ever opens for the
      // first-time OAuth handoff, never local sign-up, and there is
      // nothing in it for the user to actually fill in or decide. Submit
      // immediately instead of waiting for a click, and show a spinner
      // instead of the (disabled) form while the request round-trips.
      extend(SignUpModal.prototype, 'oncreate', function () {
        if (this.attrs.token) {
          this.onsubmit({
            preventDefault: () => {}
          });
        }
      });
      override(SignUpModal.prototype, 'body', function (original) {
        if (!this.attrs.token) {
          return original();
        }
        return m("div", {
          className: "hli-oauth-login-only-SigningIn"
        }, m(LoadingIndicator, null), m("p", {
          className: "helpText"
        }, app.translator.trans('hli-oauth-login-only.forum.sign_up.signing_in')));
      });
      override(SignUpModal.prototype, 'footer', function (original) {
        return this.attrs.token ? null : original();
      });
    });
  });
});